/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconScanSoft = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-scan-soft',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12.53a1.08 1.08 0 0 1-1.08 1.079H3.08a1.08 1.08 0 1 1 0-2.159h17.84c.597 0 1.08.483 1.08 1.08Z" }),
        React.createElement("path", { d: "M6.003 21.95c-2 0-3.203-1.451-3.203-3v-2.177a1.012 1.012 0 1 1 2.024 0v2.177c0 .5.437 1.007.937 1.007h3.246a.997.997 0 0 1 0 1.993H6.003ZM18.003 3c2 0 3.203 1.451 3.203 3v2.177a1.012 1.012 0 1 1-2.024 0V6c0-.5-.436-1.007-.936-1.007H15A.996.996 0 1 1 15 3h3.003ZM18.001 21.95c2 0 3.202-1.452 3.202-3v-2.178a1.012 1.012 0 1 0-2.023 0v2.178c0 .5-.437 1.007-.937 1.007H15a.997.997 0 0 0 0 1.993H18ZM6.005 3C4.006 3 2.803 4.452 2.803 6v2.178a1.012 1.012 0 0 0 2.024 0V6c0-.5.436-1.007.936-1.007h3.244a.997.997 0 1 0 0-1.993H6.005Z" })));
});
IconScanSoft.displayName = 'IconScanSoft';
export default IconScanSoft;
